import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getQueryFacilities } from 'store/search/searchSelectors/querySelectors';
import { updateQuery as updateQueryAction } from 'store/search/searchActions';
import FacilityFilter from 'components/Filters/Search/FacilityFilter';
import FilterItem from './FilterItem';

const FacilityFilterItem = () => {
  const dispatch = useDispatch();
  const selectedFacilities = useSelector(getQueryFacilities);

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  const clearFilters = useCallback(() => {
    updateQuery({ facilities: undefined });
  }, [updateQuery]);

  return (
    <FilterItem buttonText="Facilities" isHighlighted={(selectedFacilities || []).length > 0} clearFilters={clearFilters}>
      <FacilityFilter onChange={updateQuery} />
    </FilterItem>
  );
};

export default FacilityFilterItem;
